import React from 'react';
import { RecurringCronBasedSchedule } from '@glueapp/graph-types';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface ScheduleEditorProps {
    value: RecurringCronBasedSchedule;
    onChange: (updatedSchedule: RecurringCronBasedSchedule) => void;
}

export const CronInput: React.FC<ScheduleEditorProps> = ({ value, onChange }) => {
    const cronParts = value.cronExpression.split(' ');
    const handleCronPartChange = (index: number, newValue: string) => {
        onChange({ ...value, cronExpression: cronParts.map((part, i) => (i === index ? newValue : part)).join(' ') });
    };

    const cronFields = [
        { index: 0, label: 'Min', placeholder: '*' },
        { index: 1, label: 'Hour', placeholder: '*' },
        { index: 2, label: 'Day', placeholder: '*' },
        { index: 3, label: 'Month', placeholder: '*' },
        { index: 4, label: 'Weekday', placeholder: '*' },
    ];

    return (
        <div className="flex flex-col gap-2">
            <Label className="text-xs">Cron Expression</Label>
            <div className="grid grid-cols-5 gap-1">
                {cronFields.map(field => (
                    <div key={field.index} className="flex flex-col gap-0.5">
                        <span className="text-[10px] text-muted-foreground text-center">{field.label}</span>
                        <Input
                            type="text"
                            value={cronParts[field.index] || ''}
                            onChange={event => handleCronPartChange(field.index, event.target.value)}
                            placeholder={field.placeholder}
                            className="text-center text-xs px-1"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};
